/* Yumama cart helpers. Loaded on every page.

   1. Copy code buttons ([data-yum-copy]) on the product page, side cart and cart page.
   2. One tap adds ([data-yum-cart-add] + data-yum-qty) for the empty cart suggestion and the
      flavour suggestions. They post to /cart/add.js and ask Shopify for the rendered side cart in the
      same request, then hand it to Dawn's <cart-drawer> to paint and open. On the cart page,
      or with no drawer, the page reloads so the server paints the new cart.
   3. window.YumamaCart.add(items, button) for the product page's mixed case (two variants in
      one request).
   4. The header count. Dawn repaints #cart-icon-bubble (the desktop link) itself; the mobile
      link is a second element, so its count is copied from /cart.js after every cart change.
   5. The founding offer code, put on the cart automatically (see autoApply below).

   Line quantities are Dawn's: the steppers in the side cart and on the cart page post through
   assets/cart.js, and each step is a whole case (one unit of the case variant).

   Every listener is delegated from document, because the drawer replaces its own markup after
   every change. No money is formatted or computed here: prices come back rendered by Liquid. */
(function () {
  'use strict';

  if (window.YumamaCart) return;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function busy(button, on) {
    if (!button) return;
    button.classList.toggle('is-busy', on);
    if (on) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  function showError(message) {
    var box = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    if (box && message) {
      box.textContent = message;
      return;
    }
    if (message) window.alert(message);
  }

  function syncCount(count) {
    document.querySelectorAll('[data-yum-cart-proxy] .yum-header__icon-art').forEach(function (art) {
      var bubble = art.querySelector('.yum-header__cart-count');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'yum-header__cart-count';
          art.appendChild(bubble);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
    });
  }

  /* Codes the cart holds, painted from the cart JSON into every "Have a code?" box. Liquid
     has no list of entered codes, so this is the only place they can come from. */
  function paintCodes(cart) {
    var codes = (cart && cart.discount_codes) || [];
    document.querySelectorAll('[data-yum-havecode]').forEach(function (box) {
      var list = box.querySelector('[data-yum-codes]');
      if (!list) return;
      list.innerHTML = '';
      codes.forEach(function (dc) {
        var li = document.createElement('li');
        li.className = 'yum-havecode__chip ' + (dc.applicable ? 'is-ok' : 'is-bad');
        var code = document.createElement('span');
        code.className = 'yum-havecode__chip-code';
        code.textContent = dc.code;
        var state = document.createElement('span');
        state.className = 'yum-havecode__chip-state';
        state.textContent = box.getAttribute(dc.applicable ? 'data-label-ok' : 'data-label-bad') || '';
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'yum-havecode__chip-x';
        x.setAttribute('data-yum-discount-remove', dc.code);
        x.setAttribute('aria-label', (box.getAttribute('data-label-remove') || 'Remove') + ' ' + dc.code);
        x.innerHTML = '<svg width="10" height="10" viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        li.appendChild(code);
        li.appendChild(state);
        li.appendChild(x);
        list.appendChild(li);
      });
      list.hidden = codes.length === 0;
    });
  }

  function fetchCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) { return r.json(); });
  }

  function refreshCount() {
    return fetchCart()
      .then(function (cart) { syncCount(cart.item_count); paintCodes(cart); return cart; })
      .catch(function () {});
  }

  /* Dawn traps focus in the drawer only when it opens fresh. When it redraws while already open
     (an add from the empty state or the upsell), the tapped button is replaced and focus falls to
     the page, so Escape and Tab stop working. Put focus back in the drawer. */
  function refocus(cartDrawer) {
    window.setTimeout(function () {
      if (!cartDrawer.classList.contains('active')) return;
      var current = document.activeElement;
      if (current && current !== document.body && cartDrawer.contains(current)) return;
      var container = document.getElementById('CartDrawer') || cartDrawer;
      var target = cartDrawer.querySelector('.drawer__inner') || cartDrawer.querySelector('.drawer__close');
      if (typeof trapFocus === 'function') {
        trapFocus(container, target);
      } else if (target) {
        target.focus();
      }
    }, 400);
  }

  function add(items, button) {
    var cartDrawer = drawer();
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);
    var body = { items: items };
    if (cartDrawer && !onCartPage) {
      body.sections = SECTIONS;
      body.sections_url = window.location.pathname;
    }
    busy(button, true);
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          busy(button, false);
          showError(res.description || res.message);
          return res;
        }
        if (!cartDrawer || onCartPage || typeof cartDrawer.renderContents !== 'function') {
          window.location.reload();
          return res;
        }
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(res);
        busy(button, false);
        refocus(cartDrawer);
        // Dawn's constants.js declares PUB_SUB_EVENTS with a top level const, which is global
        // but not a property of window, so it is read by its bare name.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yumama-cart', cartData: res });
          // The auto-apply listener skips this file's own events, so the founding code is
          // checked here for these adds.
          autoApply();
        } else {
          refreshCount().then(autoApply);
        }
        return res;
      })
      .catch(function () {
        busy(button, false);
        // The network failed: fall back to the plain form post so the add still happens.
        var form = document.createElement('form');
        form.method = 'post';
        form.action = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
        items.forEach(function (item, i) {
          var pairs = [['id', item.id], ['quantity', item.quantity]];
          Object.keys(item.properties || {}).forEach(function (k) { pairs.push(['properties][' + k, item.properties[k]]); });
          pairs.forEach(function (kv) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'items[' + i + '][' + kv[0] + ']';
            input.value = kv[1];
            form.appendChild(input);
          });
        });
        document.body.appendChild(form);
        form.submit();
      });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      }
      field.remove();
    });
  }

  document.addEventListener('click', function (event) {
    var copy = event.target.closest('[data-yum-copy]');
    if (copy) {
      event.preventDefault();
      var code = copy.getAttribute('data-yum-copy');
      var label = copy.querySelector('[data-yum-copy-label]');
      var widget = copy.closest('[data-yum-code]');
      var status = widget ? widget.querySelector('[data-yum-copy-status]') : null;
      var original = label ? label.textContent : '';
      var copied = copy.getAttribute('data-yum-copied') || original;
      var done = function () {
        copy.classList.add('is-copied');
        if (widget) widget.classList.add('is-copied');
        if (label) label.textContent = copied;
        if (status) status.textContent = copied + ': ' + code;
        window.clearTimeout(copy._yumTimer);
        copy._yumTimer = window.setTimeout(function () {
          copy.classList.remove('is-copied');
          if (widget) widget.classList.remove('is-copied');
          if (label) label.textContent = original;
          if (status) status.textContent = '';
        }, 1800);
      };
      copyText(code).then(done, function () {
        // Clipboard refused (an old browser or a locked down frame): select the code so the
        // shopper can copy it by hand.
        var shown = widget ? widget.querySelector('.yum-code__code') : null;
        if (shown && window.getSelection) {
          var range = document.createRange();
          range.selectNodeContents(shown);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
      });
      return;
    }

    var addButton = event.target.closest('[data-yum-cart-add]');
    if (addButton) {
      event.preventDefault();
      if (addButton.getAttribute('aria-busy') === 'true') return;
      var qty = parseInt(addButton.getAttribute('data-yum-qty') || '1', 10);
      var item = { id: parseInt(addButton.getAttribute('data-yum-cart-add'), 10), quantity: qty > 0 ? qty : 1 };
      // The pre-order note (snippets/yumama-preorder-props, an object) rides along so the add
      // merges into the same cart line as the product page's and carries the ship date to checkout.
      var rawProps = addButton.getAttribute('data-yum-props');
      if (rawProps) {
        try {
          var props = JSON.parse(rawProps);
          if (props && typeof props === 'object' && !Array.isArray(props) && Object.keys(props).length) item.properties = props;
        } catch (e) {}
      }
      add([item], addButton);
    }
  });

  /* Discount codes. /cart/update.js takes the full list of codes the cart should hold, so the
     current list is read first and the new code added to it (or one removed from it). Shopify
     answers with each code and whether it applies; the drawer re-renders with that verdict. */
  function currentCodes() {
    return fetchCart().then(function (cart) {
      return (cart.discount_codes || []).map(function (d) { return d.code; });
    });
  }

  /* The side cart repainted where it is, closed. cart-drawer.js's renderContents always opens the
     drawer, which is right after a tap but not for a code put on the cart without one. */
  function paintDrawerQuietly(cartDrawer, res) {
    var html = res && res.sections ? res.sections['cart-drawer'] : null;
    var inner = cartDrawer.querySelector('.drawer__inner');
    if (!html || !inner || typeof DOMParser === 'undefined') return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    if (fresh) inner.innerHTML = fresh.innerHTML;
  }

  /* opts (the founding offer auto-apply only; typed codes pass none):
     quiet   no error box, no reload away from the cart page, and a closed side cart is repainted
             in place instead of opened.
     before  runs on Shopify's answer before anything is repainted or reloaded; returning false
             stops there. */
  function setCodes(codes, button, opts) {
    opts = opts || {};
    var cartDrawer = drawer();
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);
    var body = { discount: codes.join(',') };
    if (cartDrawer && !onCartPage) {
      body.sections = SECTIONS;
      body.sections_url = window.location.pathname;
    }
    busy(button, true);
    var url = (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        busy(button, false);
        if (res.status) {
          if (!opts.quiet) showError(res.description || res.message);
          return res;
        }
        if (typeof opts.before === 'function' && opts.before(res) === false) return res;
        if (!cartDrawer || onCartPage || typeof cartDrawer.renderContents !== 'function') {
          if ((onCartPage || !opts.quiet) && !checkoutPending) window.location.reload();
          else paintCodes(res);
          return res;
        }
        if (opts.quiet && !cartDrawer.classList.contains('active')) {
          paintDrawerQuietly(cartDrawer, res);
        } else {
          // renderContents swaps #CartDrawer, focus and all, and does not re-open (or re-trap) an
          // open drawer, so focus is put back as after an add.
          cartDrawer.renderContents(res);
          refocus(cartDrawer);
        }
        paintCodes(res);
        var status = document.getElementById('CartDrawer-LiveRegionText');
        var last = (res.discount_codes || []).slice(-1)[0];
        var box = document.querySelector('cart-drawer [data-yum-havecode]');
        if (status && last && box) {
          status.textContent = last.code + ' ' + (box.getAttribute(last.applicable ? 'data-label-ok' : 'data-label-bad') || '');
        }
      })
      .catch(function () { busy(button, false); });
  }

  function applyCode(code, button) {
    code = (code || '').trim().toUpperCase();
    if (!code) return;
    currentCodes().then(function (codes) {
      var upper = codes.map(function (c) { return c.toUpperCase(); });
      if (upper.indexOf(code.toUpperCase()) === -1) codes.push(code);
      setCodes(codes, button);
    }, function () { setCodes([code], button); });
  }

  function removeCode(code, button) {
    currentCodes().then(function (codes) {
      setCodes(codes.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); }), button);
    });
  }

  /* Founding offer auto-apply. The Liquid prints the offer code (Theme settings > Yumama cart and
     offers) as data-yum-auto-code on <cart-drawer> and on the cart page's <cart-items>, and only
     while the offers gate (snippets/yumama-offers-on) is on. Whenever the cart has items and does
     not hold that code, it is added through setCodes like a typed code, so the side cart and cart
     page totals already show the saving. Shopify decides eligibility: only a code it lists as
     applicable stays on and is painted. One it refuses (not applicable, for example a first order
     rule it cannot check before checkout, or missing from its answer) is taken back off without a
     repaint, so the shopper never sees a "can't be used" chip for a code they did not type; they can
     still enter it at checkout from the product page's code card.
     Runs after an add or quantity change (Dawn's cartUpdate event, and this file's own adds) and
     once on page load when the cart already has items. Guards:
     - never on an empty cart, and never when the cart already holds the code (any case);
     - one request at a time; a call that lands mid-request runs once more when it ends;
     - a shopper who removes the code keeps it off for the rest of the visit (sessionStorage,
       with an in-page copy for when storage is blocked);
     - a refused code counts the same, and nothing is repainted or reloaded for it, so the cart
       page cannot reload in a loop. */
  var AUTO_OFF_KEY = 'yumama:auto-code-off';
  var autoOffMemo = null;
  var autoBusy = false;
  var autoAgain = false;
  var autoPending = null;
  var checkoutPending = false;
  var checkoutReady = false;

  function autoCode() {
    var holder = document.querySelector('[data-yum-auto-code]');
    return holder ? (holder.getAttribute('data-yum-auto-code') || '').trim().toUpperCase() : '';
  }

  function autoOff(code) {
    if (!code || autoOffMemo === code) return true;
    try {
      return window.sessionStorage.getItem(AUTO_OFF_KEY) === code;
    } catch (e) {
      return false;
    }
  }

  function setAutoOff(code) {
    if (!code) return;
    autoOffMemo = code;
    try {
      window.sessionStorage.setItem(AUTO_OFF_KEY, code);
    } catch (e) {}
  }

  function holdsCode(cart, code, applicableOnly) {
    return ((cart && cart.discount_codes) || []).some(function (d) {
      return d && typeof d.code === 'string' && d.code.toUpperCase() === code && (!applicableOnly || !!d.applicable);
    });
  }

  /* Dawn's side cart fetches a fresh copy of itself on every cart change published by others (the
     product form's add, for one), sent at the same moment as the auto-apply. That copy predates the
     code; when it lands last it paints the lines without the saving and empties the code list,
     while the footer keeps the discounted total. So once the code is on, the side cart is fetched
     again, after it, and repainted where it is with the codes from Shopify's answer. */
  function repaintDrawer(res) {
    var cartDrawer = drawer();
    if (!cartDrawer || /\/cart\/?$/.test(window.location.pathname)) return;
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        paintDrawerQuietly(cartDrawer, { sections: { 'cart-drawer': html } });
        paintCodes(res);
        refocus(cartDrawer);
      })
      .catch(function () {});
  }

  function autoApply(cart) {
    var code = autoCode();
    if (autoOff(code)) return Promise.resolve();
    if (autoBusy) {
      autoAgain = true;
      return autoPending;
    }
    autoBusy = true;
    // A cart fetched a moment ago (refreshCount) saves a request; anything else is fetched fresh.
    var known = cart && typeof cart.item_count === 'number' && Array.isArray(cart.discount_codes);
    autoPending = (known ? Promise.resolve(cart) : fetchCart())
      .then(function (fresh) {
        if (!fresh || !(fresh.item_count > 0) || holdsCode(fresh, code) || autoOff(code)) return;
        // Wholesale has its own pricing: the retail Founding Offer code is only added when the cart
        // holds at least one retail (non wholesale) product.
        var retail = (fresh.items || []).some(function (it) { return !/wholesale/i.test(it.handle || ''); });
        if (!retail) return;
        // The same list currentCodes() reads, plus the offer code.
        var kept = (fresh.discount_codes || []).map(function (d) { return d.code; });
        var applied = null;
        var refused = false;
        return setCodes(kept.concat([code]), null, {
          quiet: true,
          before: function (res) {
            if (holdsCode(res, code, true)) {
              applied = res;
              return true;
            }
            setAutoOff(code);
            refused = holdsCode(res, code);
            return false;
          },
        }).then(function () {
          // Shopify kept a code it will not apply: the shopper's own list goes back, again with
          // no repaint or reload (the side cart and cart page still show that list).
          if (refused) return setCodes(kept, null, { quiet: true, before: function () { return false; } });
          if (applied) return repaintDrawer(applied);
        });
      })
      .catch(function () {})
      .then(function () {
        autoBusy = false;
        if (autoAgain) {
          autoAgain = false;
          return autoApply();
        }
      });
    return autoPending;
  }

  document.addEventListener('submit', function (event) {
    var button = event.submitter;
    var form = event.target;
    if (!button || button.name !== 'checkout' || checkoutReady || autoOff(autoCode())) return;
    if (form.id !== 'cart' && form.id !== 'CartDrawer-Form') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    busy(button, true);
    var formId = form.id;
    var buttonId = button.id;
    Promise.resolve(autoApply()).then(function () {
      var currentForm = document.getElementById(formId);
      var currentButton = document.getElementById(buttonId);
      checkoutPending = false;
      busy(button, false);
      busy(currentButton, false);
      if (!currentForm || !currentButton || currentButton.form !== currentForm) return;
      checkoutReady = true;
      currentForm.requestSubmit(currentButton);
      checkoutReady = false;
    }).catch(function () {
      checkoutPending = false;
      checkoutReady = false;
      busy(button, false);
    });
  }, true);

  document.addEventListener('click', function (event) {
    var apply = event.target.closest('[data-yum-discount-apply]');
    if (apply) {
      event.preventDefault();
      var box = apply.closest('[data-yum-havecode]');
      var input = box ? box.querySelector('[data-yum-discount-input]') : null;
      if (input && !input.value.trim()) { input.focus(); return; }
      applyCode(input ? input.value : '', apply);
      return;
    }
    var offer = event.target.closest('[data-yum-discount-code]');
    if (offer) {
      event.preventDefault();
      applyCode(offer.getAttribute('data-yum-discount-code'), offer);
      return;
    }
    var remove = event.target.closest('[data-yum-discount-remove]');
    if (remove) {
      event.preventDefault();
      var removed = (remove.getAttribute('data-yum-discount-remove') || '').trim().toUpperCase();
      // The shopper took the founding code off: it stays off for the rest of the visit.
      var auto = autoCode();
      if (auto && removed === auto) setAutoOff(auto);
      removeCode(removed, remove);
    }
  });

  // Enter in the code field applies the code; it must never submit the cart form to checkout.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-yum-discount-input]');
    if (!input) return;
    event.preventDefault();
    applyCode(input.value, input.closest('[data-yum-havecode]').querySelector('[data-yum-discount-apply]'));
  });

  // Keep the mobile header count honest after any cart change on the page, whoever made it, and
  // check the founding code on the cart just fetched. This file's own adds (source 'yumama-cart')
  // check it in add(), so their event is skipped here.
  function subscribeWhenReady() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var counted = refreshCount();
        if (!event || event.source !== 'yumama-cart') counted.then(autoApply);
      });
      return true;
    }
    return false;
  }
  if (!subscribeWhenReady()) {
    document.addEventListener('DOMContentLoaded', subscribeWhenReady, { once: true });
  }

  // Paint any codes already on the cart once the page is ready, and put the founding code on a
  // cart that already has items without it. The side cart and the cart page mark an empty cart
  // is-empty, so an empty cart costs no request.
  function firstPaint() {
    var holder = document.querySelector('[data-yum-auto-code]');
    var wantsCode = !!holder && !holder.classList.contains('is-empty') && !autoOff(autoCode());
    if (document.querySelector('[data-yum-havecode]') || wantsCode) {
      refreshCount().then(function (cart) {
        if (wantsCode) autoApply(cart);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', firstPaint, { once: true });
  else firstPaint();

  window.YumamaCart = { add: add, refreshCount: refreshCount, paintCodes: paintCodes };
})();
